import { readSubsegmentSummaryFromAcf } from "./expansionProjectAcf";

export function normalizeProjectSearchQuery(query) {
  return String(query || "").trim().toLowerCase();
}

/** Match commercial or expansion project rows by work order or project name. */
export function rowMatchesProjectSearch(row, query) {
  const q = normalizeProjectSearchQuery(query);
  if (!q || !row || row._rowType === "group") return true;

  const wo = String(row.work_order ?? "").toLowerCase();
  if (wo.includes(q)) return true;

  const name = String(row.name ?? "").toLowerCase();
  if (name.includes(q)) return true;

  const sub = readSubsegmentSummaryFromAcf(row.acf_groups_json);
  const subName = String(sub?.project_name ?? sub?.segment_name ?? "").toLowerCase();
  if (subName.includes(q)) return true;

  return false;
}
